import React from "react";
import CrisisSystemMessage from "./CrisisSystemMessage";

/**
 * @typedef Message
 * @type {object}
 * @property {number} id
 * @property {"info" | "warning" | "sos"} alertLevel - the severity level of the message.
 * @property {string} message - a string of text and html with the error message
 */

export default function CrisisSystemMessages({ settings }) {
  const alerts = settings?.funditAlerts;
  const isSuperAdmin = settings?.isSuperAdmin;
  const isGroupAdmin = settings?.isGroupAdminForAnyGroup;
  const networkIsSignedUpForPayments = settings?.networkIsSignedUpForPayments;
  const userCanView =
    (isSuperAdmin || isGroupAdmin) && networkIsSignedUpForPayments;

  if (!alerts) return null;

  // Temporarily hard set this until we come up with a permissions system for additional alerts besides the fundit alert
  if (!userCanView) return null;

  return (
    <div>
      {alerts.map((m) => (
        <CrisisSystemMessage key={m.id} messageObj={m} />
      ))}
    </div>
  );
}

// EXAMPLES
const testwarnings = [
  {
    id: 123,
    alertLevel: "sos",
    message: "This is a message <strong>with some bold text</strong>",
  },
  {
    id: 321,
    alertLevel: "warning",
    message:
      "This is a really important message <strong>with some bold text</strong>",
  },
  {
    id: 231,
    alertLevel: "info",
    message:
      "This is an informational message <strong>with some bold text</strong>. It is not important. It is just informational. Really informational. Something informational.",
  },
];
